import { render, staticRenderFns } from "./WebsiteHeaderSplit.vue?vue&type=template&id=720bb890"
import script from "./WebsiteHeaderSplit.vue?vue&type=script&lang=ts"
export * from "./WebsiteHeaderSplit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports